import { render, staticRenderFns } from "./AlertsDetails.vue?vue&type=template&id=17c77ad0&scoped=true&"
import script from "./AlertsDetails.vue?vue&type=script&lang=js&"
export * from "./AlertsDetails.vue?vue&type=script&lang=js&"
import style0 from "./AlertsDetails.vue?vue&type=style&index=0&id=17c77ad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c77ad0",
  null
  
)

export default component.exports